import getApi from '../../api/apisauceConfig'
import { serializeQuestionInstance } from './mapper/questionInstances.mapper'
import { QuestionInstanceMutationPayload } from './mapper/questionInstances.model'
import { QuestionInstance } from '../../model/Questionnaire'

export const updateQuestionInstance = (id: number, payload: QuestionInstanceMutationPayload) =>
  getApi().put<QuestionInstance>(`/question_instances/${id}`, serializeQuestionInstance(payload))
